module.exports = __webpack_public_path__ + "images/application/i-cc-9d5d29c8.png";